<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <b-modal v-model="visible" centered title="Amazon bucket access">
      <label>Access key ID</label>
      <ValidationProvider
        rules="required"
        v-slot="{ errors }"
        name="Access key ID"
      >
        <b-form-input v-model="keyID" />

        <div class="validation-error mb-3">
          <span v-if="submitted">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>

      <label>Secret access key</label>
      <ValidationProvider
        rules="required"
        v-slot="{ errors }"
        name="Secret access key"
      >
        <b-form-input v-model="secretKey" />

        <div class="validation-error mb-3">
          <span v-if="submitted">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>

      <div slot="modal-footer">
        <b-button class="mr-2" variant="primary" @click="onCancel()">
          Cancel
        </b-button>

        <b-button @click="onOK()" :disabled="submitted && invalid">
          OK
        </b-button>
      </div>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import { mapMutations } from "vuex";
import AWS from "aws-sdk";

export default {
  name: "AmazonLogin",
  data() {
    return {
      visible: false,
      keyID: "",
      secretKey: "",
      resolve: null,
      reject: null,
      submitted: false
    };
  },
  methods: {
    ...mapMutations(["setS3CredentialsSet"]),
    show() {
      this.keyID = process.env.VUE_APP_S3_KEYID;
      this.secretKey = process.env.VUE_APP_S3_SECRETKEY;

      this.visible = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    close(result) {
      if (result === true) {
        this.resolve(true);
      } else {
        this.reject(result);
      }

      // clear data
      this.keyID = "";
      this.secretKey = "";

      this.visible = false;
    },
    async onOK() {
      this.submitted = true;

      if (await this.$refs.observer.validate()) {
        // Set amazon credentials
        AWS.config.update({
          accessKeyId: this.keyID,
          secretAccessKey: this.secretKey
        });

        this.setS3CredentialsSet();
        this.close(true);
      }
    },
    onCancel() {
      this.close("Cancelled");
    }
  }
};
</script>
